import AssetsCards from '../../components/Assets/AssetsCards';
import ListingPage from '../../components/ListingPage';

const AssetsPage = () => {
  return <ListingPage entityType="asset" filterBy="title" Cards={AssetsCards} />;
};

export default AssetsPage;
